import React from 'react'
import get from 'lodash/get'
import { Input, InputError } from '@foodsby/nutrient'

const UserInfo = ({
  email,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
}) => {
  const getError = name => get(touched, name) && get(errors, name)
  return (
    <div className="row">
      <div className="col-xs-12 col-sm-6">
        <div className="Input is-inactive">
          <label htmlFor="email">Email</label>
          <p id="email">{email}</p>
        </div>
      </div>
      <div className="col-xs-12 col-sm-6">
        <div className="Input">
          <Input
            autoComplete="home tel"
            format="(###)  ###-####"
            id="User.phone"
            isValid={!getError('User.phone')}
            label="Phone Number"
            mask="_"
            name="User.phone"
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder="(___) ___-____"
            value={values.User.phone}
          />
          <InputError>{getError('User.phone')}</InputError>
        </div>
      </div>
      <div className="col-xs-12 col-sm-6">
        <div className="Input">
          <Input
            autoComplete="given-name"
            id="User.firstName"
            isValid={!getError('User.firstName')}
            label="First Name"
            maxLength="35"
            name="User.firstName"
            onBlur={handleBlur}
            onChange={handleChange}
            type="text"
            value={values.User.firstName}
          />
          <InputError className="Input-error">
            {getError('User.firstName')}
          </InputError>
        </div>
      </div>
      <div className="col-xs-12 col-sm-6">
        <div className="Input">
          <Input
            autoComplete="family-name"
            id="User.lastName"
            isValid={!getError('User.lastName')}
            label="Last Name"
            maxLength="35"
            name="User.lastName"
            onBlur={handleBlur}
            onChange={handleChange}
            type="text"
            value={values.User.lastName}
          />
          <InputError className="Input-error">
            {getError('User.lastName')}
          </InputError>
        </div>
      </div>
    </div>
  )
}
export default UserInfo
